import React from 'react';
import { Redirect } from 'react-router-dom';

const Home = () => {
	return <Redirect to="/client/quotes/request" />
}

export default Home;